// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.battery-indicator {
  position: fixed;
  top: 6px;
  right: 8px;
  z-index: 99999;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  border-radius: 999px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  letter-spacing: 0.3px;
}

.battery-indicator .bi-icon { display: block; }

.battery-indicator.is-charging { color: #66ff99; }
.battery-indicator.is-charging .bi-icon { color: #66ff99; }

.battery-indicator.is-low { color: #ff6e6e; }
.battery-indicator.is-low .bi-icon { color: #ff6e6e; }

.battery-indicator.is-unknown { color: #ffd54f; }
.battery-indicator.is-unknown .bi-icon { color: #ffd54f; }

.battery-indicator .bi-pct { color: inherit; }
`, "",{"version":3,"sources":["webpack://./src/components/BatteryIndicator.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;EACX,oBAAoB;EACpB,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,8BAA8B,cAAc,EAAE;;AAE9C,iCAAiC,cAAc,EAAE;AACjD,0CAA0C,cAAc,EAAE;;AAE1D,4BAA4B,cAAc,EAAE;AAC5C,qCAAqC,cAAc,EAAE;;AAErD,gCAAgC,cAAc,EAAE;AAChD,yCAAyC,cAAc,EAAE;;AAEzD,6BAA6B,cAAc,EAAE","sourcesContent":[".battery-indicator {\n  position: fixed;\n  top: 6px;\n  right: 8px;\n  z-index: 99999;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  border-radius: 999px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n  letter-spacing: 0.3px;\n}\n\n.battery-indicator .bi-icon { display: block; }\n\n.battery-indicator.is-charging { color: #66ff99; }\n.battery-indicator.is-charging .bi-icon { color: #66ff99; }\n\n.battery-indicator.is-low { color: #ff6e6e; }\n.battery-indicator.is-low .bi-icon { color: #ff6e6e; }\n\n.battery-indicator.is-unknown { color: #ffd54f; }\n.battery-indicator.is-unknown .bi-icon { color: #ffd54f; }\n\n.battery-indicator .bi-pct { color: inherit; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
